import React from 'react';
import PropTypes, { string, object } from 'prop-types';
import styled from 'styled-components';
import { Col } from 'react-materialize';
import { COLOR, SIZE, SCREEN_MEDIA, FONT_FAMILY } from '../../utils/constants.js';
import { Label } from '../atoms/label.jsx';
import Row from './row.jsx';
import TitleSect from '../atoms/titlesect.jsx';
import Bullets from '../molecules/bullets.jsx';


const Img = styled.img`
    //border: 10px solid #FFFEEE;
`;

const Content = styled.div`
    display: inherit;
    height: inherit;
    ${props => props.info_background_color ? 'background: ' + props.info_background_color + ';' : 'none;'}
    ${props => props.info_background_color ? 'border-radius: 25px;' : 'none;'}
    ${props => props.info_background_color ? 'padding-left: 20px;' : 'none;'}
    ${props => props.info_background_color ? 'padding-right: 20px;' : 'none;'}
    ${props => props.info_background_color ? 'padding-top: 15px;' : 'none;'}
    ${props => props.info_background_color ? 'padding-bottom: 15px;' : 'none;'}
    @media only screen and ${SCREEN_MEDIA.small} {
        margin: 40px 0;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        margin: 50px 0;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        margin: 60px 0;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        margin: 0 20px;
    }
`;

const Subtitle = styled(Label)`
    font-size: ${SIZE.title};
    color: ${COLOR.gray};
    margin: 30px 0 0 0;
`;

const Description = styled(Label)`
    margin: ${props => props.margin ? props.margin : '0 0'};
    line-height: 1.1em;
    color: ${COLOR.ferra};
`;

const DescsContent = styled.div`
    margin: 35px 0 0 0;
`;

const RowInfo = (props) => {

    const listDesc = props.descs?.map((desc, index) =>
        <Description
            key={index}
            text_color={COLOR.black}
            text_size={SIZE.title}
            font_family={FONT_FAMILY.avenirMedium}
            margin='25px 0 0 0'>
            {desc}
        </Description>
    );
    const descs = <DescsContent>{listDesc}</DescsContent>


    if(props.img_right === true) {
        return (
            <Row className='valign-wrapper' margin={props.margin} padding={props.padding}>
                <Col s={12} m={8} l={12} xl={6}>
                    <Content
                        info_background_color={props.info_background_color}>
                        <TitleSect>{props.title}</TitleSect>
                        {descs}
                        <Bullets
                            items={props.bullet_items}
                            margin='20px 0'
                            item_text_size={SIZE.title}
                            item_text_color={COLOR.ferra}
                            font_family={FONT_FAMILY.avenirMedium}
                            />

                        <Subtitle
                            font_family={FONT_FAMILY.unicorns}>
                            {props.subtitle1}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc1}
                        </Description>

                        <Subtitle
                            font_family={FONT_FAMILY.unicorns}>
                            {props.subtitle2}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc2}
                        </Description>
                    </Content>
                </Col>
                <Col s={12} m={12} l={6} xl={6} offset='m2 l2'>
                    <Img className='responsive-img' src={props.img_path}/>
                </Col>
            </Row>
        );
    } else {
        return (
            <Row className='valign-wrapper' margin={props.margin} padding={props.padding}>
                <Col s={12} m={8} l={8} xl={6} offset='m2 l2'>
                    <Img className='responsive-img' src={props.img_path}/>
                </Col>
                <Col s={12} m={12} l={12} xl={6}>
                    <Content
                        info_background_color={props.info_background_color}>
                        <TitleSect>{props.title}</TitleSect>
                        {descs}
                        <Bullets
                            items={props.bullet_items}
                            margin='20px 0'
                            item_text_size={SIZE.subtitle}
                            item_text_color={COLOR.ferra}
                            font_family={FONT_FAMILY.avenirMedium}
                            />

                        <Subtitle
                            font_family={FONT_FAMILY.unicorns}>
                            {props.subtitle1}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc1}
                        </Description>

                        <Subtitle
                            font_family={FONT_FAMILY.unicorns}>
                            {props.subtitle2}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc2}
                        </Description>
                    </Content>
                </Col>
            </Row>
        );
    }
    
}

RowInfo.propTypes = {
    img_path: PropTypes.string.isRequired,
    img_right: PropTypes.bool,
    info_background_color: PropTypes.string,
    title: PropTypes.string,
    descs: PropTypes.arrayOf(string),
    bullet_items: PropTypes.arrayOf(object),
    subtitle1: PropTypes.string,
    desc1: PropTypes.string,
    subtitle2: PropTypes.string,
    desc2: PropTypes.string,
    margin: PropTypes.string,
    padding: PropTypes.string
}

export default RowInfo;